<template>
  <div id="supplier-express-address-change">
    <el-dialog title="重要提示" @close="mailAddressSubmit" @open="mailAddressModal.isNotRemind = false;" custom-class="mail-address-modal" v-model="mailAddressModal.visible" size="tiny">
      <span class="mail-address-title" slot="title">重要提示</span>
      <div class="mail-address-content">
        <div class="desc">商品办签资料邮寄地址已变更，请支付完成后查看最新地址再邮寄</div>
        <div class="checkbox-box">
          <el-checkbox v-model="mailAddressModal.isNotRemind">相同邮寄地址不再提醒</el-checkbox>
        </div>
        <el-button type="primary" size="large" class="btn" @click="mailAddressModal.visible = false">知道了</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Http from '../../../../libs/http';
import User from '../../../../libs/user';

export default {
  name: 'supplier-express-address-change',
  props: {
    product: {
      type: Object,
      required: true,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      mailAddressModal: {
        visible: false,
        isNotRemind: false,
        visa_supplier_id: 0,
      },
    };
  },
  methods: {

    // 邮寄地址更改提示弹窗关闭触发
    mailAddressSubmit() {
      if (!this.mailAddressModal.visa_supplier_id) return;
      Http.post('/peer_account_warn_status_update', {
        visa_product_id: this.product.visa_product_id,
        status: this.mailAddressModal.isNotRemind ? 2 : 1,
        visa_supplier_id: this.mailAddressModal.visa_supplier_id,
      }).then(() => {
      });
    },

    // 查询供应商邮寄地址是否更改，更改了则弹窗提示
    mailAddressQuery() {
      Http.post('/supplier_address_changed_warn', {
        visa_product_id: this.product.visa_product_id,
      }).then((data) => {
        if (data.status === 0) {
          // 需要提醒
          this.mailAddressModal.visa_supplier_id = data.visa_supplier_id;
          this.mailAddressModal.visible = true;
        }
      });
    },

    // 判断是否包含纸质资料
    isIncludePaperMaterial(product) {
      const isIncludePaperMaterial = product.material.some((item) => {
        // 必须资料是否有纸质资料
        const isIncludeRequiredPaperMaterial = item.material_required.some(materialItem => materialItem.attr === 1);
        // 可选资料是否有纸质资料
        const isIncludeOptionalPaperMaterial = item.material_optional.some(materialItem => materialItem.attr === 1);
        return isIncludeRequiredPaperMaterial || isIncludeOptionalPaperMaterial;
      });
      return isIncludePaperMaterial;
    },

    loadForProduct(product) {
      if (product.visa_product_id) {
        if (User.isLogin()) {
          // 判断供应商邮寄地址是否变更
          // 当为在线上传，且没有任何纸质资料时，就不提醒
          if (product.offline === 1 || this.isIncludePaperMaterial(product)) {
            this.mailAddressQuery();
          }
        }
      }
    },
  },
  watch: {
    product(newVal) {
      this.loadForProduct(newVal);
    },
  },
  created() {
    this.loadForProduct(this.product);
  },
};
</script>

<style lang="less" scoped>
#supplier-express-address-change {
  display: flex;
  /deep/ .mail-address-modal{
    width: 420px;
    .el-dialog__header{
      border-bottom: 1px solid #f0f0f0;
      padding: 22px 20px 18px 20px;
      text-align: center;
      .mail-address-title{
        font-size: 16px;
        color: #333;
        font-weight: 600;
      }
      .el-dialog__close{
        font-size: 15px;
        color: #777;
      }
    }
    .el-dialog__body{
      padding: 30px;
      .desc{
        font-size: 16px;
        margin-bottom: 20px;
        color: #333333;
        line-height: 1.5;
      }
      .checkbox-box{
        margin-bottom: 20px;
        .el-checkbox{
          color: #333333;
        }
      }
    }
    .btn{
      width: 100%;
      font-size: 16px;
      padding: 12px 19px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/product/product-info/components/supplier-express-address-change.vue